import { useEffect, useState } from 'react';
import { api } from '../api.js';
import { Button, Card, Field, Badge, Empty, Spinner } from '../ui.jsx';

export default function Targets({ notify, onReport }) {
  const [list, setList] = useState(null);
  const [form, setForm] = useState({ url: '', title: '' });

  const load = () =>
    api('/api/targets')
      .then((d) => setList(d.targets))
      .catch((e) => notify({ ok: false, msg: e.message }));

  useEffect(() => {
    load();
  }, []);

  async function add(e) {
    e.preventDefault();
    if (!form.url.trim()) return notify({ ok: false, msg: 'اكتب الرابط أولاً' });
    try {
      await api('/api/targets', { method: 'POST', body: form });
      setForm({ url: '', title: '' });
      notify({ ok: true, msg: 'تمت إضافة الرابط ✅' });
      load();
    } catch (e2) {
      notify({ ok: false, msg: e2.message });
    }
  }

  const toggle = async (t) => {
    await api(`/api/targets/${t.id}`, { method: 'PATCH', body: { enabled: !t.enabled } });
    load();
  };

  const remove = async (t) => {
    if (!confirm(`حذف «${t.title}»؟`)) return;
    await api(`/api/targets/${t.id}`, { method: 'DELETE' });
    notify({ ok: true, msg: 'تم الحذف' });
    load();
  };

  return (
    <>
    <Card title="إضافة رابط مستهدف">
      <form className="row-form" onSubmit={add}>
        <Field label="الرابط" required>
          <input
            value={form.url}
            onChange={(e) => setForm({ ...form, url: e.target.value })}
            placeholder="https://facebook.com/page"
          />
        </Field>
        <Field label="الاسم الوصفي">
          <input
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
            placeholder="مثال: صفحة تحitory — حسابات وهمية"
          />
        </Field>
        <Button type="submit" variant="primary" className="align-end">
          إضافة
        </Button>
      </form>
    </Card>

    <Card title={`الروابط (${list?.length ?? 0})`}>
      {!list ? (
        <Spinner />
      ) : !list.length ? (
        <Empty>لا توجد روابط بعد — أضف أول رابط من الأعلى</Empty>
      ) : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>الاسم</th>
                <th>الرابط</th>
                <th>الحالة</th>
                <th>البلاغات</th>
                <th className="ta-c">إجراءات</th>
              </tr>
            </thead>
            <tbody>
              {list.map((t) => (
                <tr key={t.id}>
                  <td className="muted">{t.id}</td>
                  <td><b>{t.title}</b></td>
                  <td>
                    <a href={t.url} target="_blank" rel="noreferrer" className="link">
                      {t.url}
                    </a>
                  </td>
                  <td>
                    <Badge tone={t.enabled ? 'ok' : 'warn'}>{t.enabled ? 'مفعّل' : 'موقوف'}</Badge>
                  </td>
                  <td className="muted">{t.count ?? 0}</td>
                  <td>
                    <div className="actions">
                      {t.enabled && onReport && (
                        <Button size="sm" variant="primary" onClick={() => onReport(t.id)}>
                          بلاغ
                        </Button>
                      )}
                      <Button size="sm" onClick={() => toggle(t)}>
                        {t.enabled ? 'إيقاف' : 'تفعيل'}
                      </Button>
                      <Button size="sm" variant="danger" onClick={() => remove(t)}>
                        حذف
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
    </>
  );
}